import { useEffect, useState } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import {
  useVehiclesListQuery,
  VehicleRead,
} from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

interface VehicleSelectionFieldProps {
  onlySchedulable?: boolean;
  filterVehicles?: (options: SelectOption<string>[]) => SelectOption<string>[];
}
export function VehicleSelectionField({
  onlySchedulable,
  filterVehicles,
}: VehicleSelectionFieldProps) {
  const { data: vehicles, isFetching } = useVehiclesListQuery({
    canBeScheduled: onlySchedulable,
  });
  const [vehicleOptions, setVehicleOptions] = useState<SelectOption<string>[]>(
    []
  );

  useEffect(() => {
    if (vehicles?.results) {
      const options: SelectOption<string>[] = vehicles.results.map(
        (vehicle: VehicleRead) => {
          return {
            label: vehicle.nickname || vehicle.id,
            value: vehicle.id,
          };
        }
      );
      if (filterVehicles) {
        setVehicleOptions(filterVehicles(options));
      } else {
        setVehicleOptions(options);
      }
    }
  }, [vehicles, filterVehicles]);
  return (
    <div>
      <FormFieldController
        name="vehicle"
        rules={{ required: 'Vehicle is required' }}
      >
        {({ field, fieldState }) => {
          return (
            <DefaultFormFieldLayout
              label="Vehicle *"
              error={fieldState.error?.message?.toString()}
              inputId="vehicle-id"
            >
              <Select
                selected={field.value}
                options={vehicleOptions}
                onChange={field.onChange}
                placeholder={
                  isFetching ? 'Loading vehicles...' : 'Select a vehicle'
                }
                disabled={isFetching}
              />
            </DefaultFormFieldLayout>
          );
        }}
      </FormFieldController>
    </div>
  );
}
